import React, { useEffect, useState } from "react";
import { object, array, string, number } from "prop-types";
import { StoryElement, WithLazy } from "@quintype/components";
import YouTube from "react-youtube";
import getYouTubeID from "get-youtube-id";
import { get } from "lodash";

import { cancelablePromise } from "../../utils/utils";
import { getStory } from "../../helper/api";

import "./cardVideo.m.css";

const YoutubePlayer = ({ element, autoPlay, className }) => {
  const options = {
    playerVars: {
      autoplay: autoPlay,
      allow: "autoplay; encrypted-media",
      mute: 1,
    },
  };

  return <YouTube className={className} videoId={getYouTubeID(element.url)} opts={options} />;
};

const CardVideo = ({ aspectRatio = [3, 2], story, autoPlay, imageType = "image3x2" }) => {
  const wrapperStyleName = `qt-video-dynamic ${imageType}`;
  const template = get(story, ["story-template"]);

  if (!(story && template === "video")) {
    return null;
  }

  const [cards, setCards] = useState([]);

  useEffect(() => {
    const promise = cancelablePromise(getStory(story?.id));
    promise.promise
      .then(({ story }) => {
        setCards(story?.cards);
      })
      .catch(console.log);

    return () => promise.cancel();
  }, []);

  const youtube = cards
    .flatMap((card) => card?.["story-elements"])
    .find((element) => element?.type === "youtube-video");

  return (
    <div styleName={`${wrapperStyleName} card-video-wrapper`} className={`${wrapperStyleName} card-video-wrapper`}>
      <figure className="qt-figure">
        <picture className="qt-video default">
          {youtube && (
            <WithLazy margin="50px">
              {() => (
                <StoryElement
                  autoPlay={autoPlay}
                  element={youtube}
                  className="qt-video  default"
                  aspectRatio={aspectRatio}
                  widths="100%"
                  height="100%"
                  renderTemplates={{ "youtube-video": YoutubePlayer }}
                  story={story}
                />
              )}
            </WithLazy>
          )}
        </picture>
      </figure>
    </div>
  );
};

YoutubePlayer.propTypes = {
  element: object,
  autoPlay: number,
  className: string,
};

CardVideo.propTypes = {
  story: object,
  autoPlay: number,
  defaultWidth: number,
  imageType: string,
  widths: array,
  aspectRatio: array,
};

export default CardVideo;
